import { useState } from "react";
import "./Contactus.css";
import {Helmet} from "react-helmet";
export default function App() {
  const [message, setMessage] = useState(""); // State to hold the success message

  function Submit(e) {
    e.preventDefault(); // Prevent default form submission behavior
    const formEle = document.querySelector("form");
    const formDatab = new FormData(formEle);

    fetch(
      "https://script.google.com/macros/s/AKfycbyoTUbcELuAYWRmj0Zo4_QsE74kNWqmYV7IKtft7-S4vl2dF1M2SE4MsNlwttHsUWJGHw/exec",
      {
        method: "POST",
        body: formDatab
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log('Success:', data);
        // Set the success message when the form is submitted successfully
        if (data.status === 'success') {
          setMessage("Your message has been successfully submitted!");
          // Reset the form fields
          formEle.reset();
        }
      })
      .catch((error) => {
        console.log('Error:', error);
        setMessage("There was an error submitting your message. Please try again.");
      });
  }

  return (
    <div className="App">
      <div className="form-container">
      <Helmet>
                <meta charSet="utf-8" />
                <title>Contact Us - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
        <h1>Contact Us</h1>
        <form className="form" onSubmit={(e) => Submit(e)}>
          <div className="form-row">
            <input placeholder="Name" name="Name" type="text" required />
          </div>
          <div className="form-row">
            <input placeholder="Email" name="Email" type="email" required />
          </div>
          <div className="form-row">
            <input
              placeholder="Contact No"
              name="Contact_No"
              type="tel"
              pattern="[0-9]{10}"
              required
            />
          </div>
          <div className="form-row">
            <input placeholder="Subject" name="Subject" type="text" required />
          </div>
          <div className="form-row">
            <textarea
              placeholder="Your Message"
              name="Message"
              rows="4"
              required
            ></textarea>
          </div>
          <div className="form-row">
            <input name="Submit" type="submit" value="Send Message" />
          </div>
        </form>
        {message && <p className="message">{message}</p>} {/* Display success/error message */}
      </div>
    </div>
  );
}
